import '../../styles/UrmSimulatorPage.css';
import {useState} from "react";
import UrmRunModeComponent from "./UrmRunModeComponent.jsx";
import UrmCreateModeComponent from "./UrmCreateModeComponent.jsx";
import {UnlimitedRegisterMachine} from "../../js/entities/UnlimitedRegisterMachine/UnlimitedRegisterMachine";
import {areArraysEqual} from "../../js/utils";
import NavBar from "../components/NavBar";

export default function UrmSimulatorPage() {
    // current mode
    const [currentMode, setCurrentMode] = useState('CREATE'); // CREATE, RUN

    // state of CREATE mode
    const [createModeState, setCreateModeState] = useState({
        registersInput: [0],                    // number[] (not adjusted according to the maximum used register index in URM program)
        urmProgramCodeInEditor: '',             // string
        compiledUrmProgram: undefined,          // UrmProgram
        urmCompilationErrors: undefined         // UrmProgramCompilingError[]
    });

    // state of RUN mode
    const [runModeState, setRunModeState] = useState({
        initialRegisters: undefined,            // number[]
        urmProgram: undefined,                  // UrmProgram
        history: [],                            // UrmMemento[]
        currentIndexInHistory: undefined,       // number
        stepsLimit: 100                         // number (steps limit when execute full UrmProgram), max is 1,000
    });

    /**
     * Changes current mode from CREATE to RUN.
     *
     * Should be called only when <code>createModeState.compiledUrmProgram</code> is not <code>undefined</code>.
     */
    const handleSwitchToRunMode = () => {
        // here, createModeState.compiledUrmProgram is not undefined

        let adjustedRegistersInput = adjustRegistersInputAccordingToUrmProgram();

        if(runModeState.urmProgram === undefined || runModeState.initialRegisters === undefined || // first time entering RUN mode
            runModeState.urmProgram.toString() !== createModeState.compiledUrmProgram.toString() || // something is changed since last entering RUN mode
            !areArraysEqual(runModeState.initialRegisters, adjustedRegistersInput)){
            // init runModeState by new entities

            let urm = // create URM only for creating history
                new UnlimitedRegisterMachine(createModeState.compiledUrmProgram,
                    adjustedRegistersInput);


            setRunModeState((state) => ({
                initialRegisters: adjustedRegistersInput,
                urmProgram: createModeState.compiledUrmProgram,
                history: [urm.saveState()],
                currentIndexInHistory: 0,
                stepsLimit: 100
            }));
        }
        // else, nothing (urmProgram, initialRegisters) has changed since last entering RUN mode,
        // so any initializations are required


        setCurrentMode((mode) => 'RUN');
    }

    const handleSwitchToCreateMode = () => {
        setCurrentMode((mode) => 'CREATE');
    }

    /**
     * Copies <code>createModeState.inputRegisters</code>, and adjusts this copy size to
     * maximum register index used in <code>createModeState.inputRegisters</code> urmProgram.
     * Added registers will have value of <code>0</code>.
     * @returns {number[]} adjusted copy of <code>createModeState.inputRegisters</code>
     */
    const adjustRegistersInputAccordingToUrmProgram = () => {
        let numberOfRequiredRegisters = Math.max(
            createModeState.compiledUrmProgram.getMaximumMentionedRegisterIndex() + 1,
            createModeState.registersInput.length);

        let complementArray =
            Array(numberOfRequiredRegisters - createModeState.registersInput.length).fill(0);

        return createModeState.registersInput.concat(complementArray);
    }


    return (
        <>
            <NavBar activeTab={'urm'}/>

            <div className={'container mt-2'}>
                <h1>URM Simulator</h1>

                {(currentMode === 'CREATE') ? (
                    <UrmCreateModeComponent
                        createModeState={createModeState}
                        setCreateModeState={setCreateModeState}
                        switchToRunMode={handleSwitchToRunMode}
                    />
                ) : (
                    <UrmRunModeComponent
                        runModeState={runModeState}
                        setRunModeState={setRunModeState}
                        switchToCreateMode={handleSwitchToCreateMode}/>
                )}
            </div>
        </>
    );
}